import api from './api';

export const createSurvey = async data => {
  try {
    const response = await api.post(`/surveys/add/`, data);
    return response.data;
  } catch (error) {
    console.error(
      'Error al crear la encuesta:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

export const getAll = async (is_active = 1) => {
  try {
    const response = await api.get(`/surveys/getAll/${is_active}`);
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener las encuestas:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

export const getSurveyById = async id => {
  try {
    const response = await api.get(`/surveys/getSurveyById/${id}`);
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener la encuesta por ID:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

// Servicio para actualizar una encuesta
export const updateSurvey = async (id, data) => {
  try {
    const response = await api.put(`/surveys/update/${id}`, data);
    return response.data;
  } catch (error) {
    console.error(
      'Error al actualizar la encuesta:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

// Servicio para agregar un grupo de preguntas
export const addQuestionGroup = async data => {
  try {
    const response = await api.post(`/questionGroups/add`, data);
    return response.data;
  } catch (error) {
    console.error(
      'Error al agregar el grupo de preguntas:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

// Servicio para obtener todos los grupos de preguntas de una encuesta
export const getAllQuestionGroups = async survey_id => {
  try {
    const response = await api.get(`/questionGroups/getAll/${survey_id}`);
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener los grupos de preguntas:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

// Servicio para obtener un grupo de preguntas por ID
export const getQuestionGroupById = async id => {
  try {
    const response = await api.get(`/questionGroups/getById/${id}`);
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener el grupo de preguntas por ID:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

// Servicio para actualizar un grupo de preguntas
export const updateQuestionGroup = async (id, data) => {
  try {
    const response = await api.put(`/questionGroups/update/${id}`, data);
    return response.data;
  } catch (error) {
    console.error(
      'Error al actualizar el grupo de preguntas:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

// Servicio para eliminar lógicamente un grupo de preguntas
export const removeQuestionGroup = async (id, timeZone) => {
  try {
    const response = await api.delete(`/questionGroups/remove/${id}`, {
      data: { timeZone } // Enviar el timeZone en el cuerpo de la solicitud
    });
    return response.data;
  } catch (error) {
    console.error(
      'Error al eliminar el grupo de preguntas:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};
